import * as React from 'react'
import { CarouselContext, State, Action } from './'

type CarouselProviderProps = { children: React.ReactNode }

const carouselReducer = (state: State, action: Action) => {
  switch (action.type) {
    // Increment +1 to proceed right in the carousel
    case 'increment': {
      return { activeIndex: state.activeIndex + 1 }
    }
    // Decrement -1 to proceed left in the carousel
    case 'decrement': {
      return { activeIndex: state.activeIndex - 1 }
    }
    // Set to an arbitrary index in the carousel
    case 'set': {
      return { activeIndex: action.payload }
    }
  }
}

const CarouselProvider = ({ children }: CarouselProviderProps) => {
  const [state, dispatch] = React.useReducer(carouselReducer, {
    activeIndex: 0,
  })
  const value = { state, dispatch }
  return (
    <CarouselContext.Provider value={value}>
      {children}
    </CarouselContext.Provider>
  )
}

export default CarouselProvider
